import { ToggleProps } from "./types";

const Toggle: React.FC<ToggleProps> = (props) => {
  const { id, label, name, value, onChange } = props;
  const handleToggle = () => {
    // Kada korisnik klikne, promeni stanje
    onChange(id, name, !value);
  };

  return (
    <div className="">
      {label && (
        <label className="block mb-3 text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <div
        className="relative inline-flex items-center cursor-pointer"
        onClick={handleToggle}
      >
        <div
          className={`w-9 h-5 rounded-full ${
            value ? "bg-blue-600" : "bg-gray-300"
          } transition-colors duration-300`}
        >
          <div
            className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
              value ? "translate-x-5" : ""
            }`}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Toggle;
